import { createSlice } from "@reduxjs/toolkit";

interface LoginData {
  modalTitle: string;
  showLoginModal: boolean;
  isAcceptTC: boolean;
  email: string;
  phone: string;
  otp: string;
  countryCode: string;
  phoneOtp: string;
  showOtp: boolean;
  showPhoneOtp: boolean;
  sessionUUId: string;
  generateOtpReq: {
    version: string;
    status: string;
    error: string;
  };
  verifyOtpReq: {
    status: string;
    error: string;
  };
  googleOneTapLoaded: boolean;
  openingSource?: string;
  onBack?: () => void;
}

export const initialState: LoginData = {
  modalTitle: "",
  showLoginModal: false,
  countryCode: "",
  phone: "",
  email: "",
  otp: "",
  phoneOtp: "",
  showPhoneOtp: false,
  showOtp: false,
  sessionUUId: "",
  generateOtpReq: {
    version: "",
    status: "invalid",
    error: "",
  },
  verifyOtpReq: {
    status: "invalid",
    error: "",
  },
  googleOneTapLoaded: false,
  openingSource: "",
  isAcceptTC: true,
};

const loginData = createSlice({
  name: "login",
  initialState: initialState as LoginData,
  reducers: {
    changeLoginModalTitle: (state, { payload }) => ({
      ...state,
      modalTitle: payload?.title || "",
      onBack: payload?.onBack || null,
    }),
    showLoginModal: (state, { payload }) => {
      state.showLoginModal = true;
      if (payload.openingSource) state.openingSource = payload.openingSource;
    },
    hideLoginModal: (state) => {
      state.showLoginModal = false;
      state.openingSource = "";
    },
    onEmailChanged: (state, { payload }) => {
      state.email = payload;
    },
    onPhoneChanged: (state, { payload }) => {
      state.phone = payload;
      state.generateOtpReq.error = "";
    },
    onCountryCodeChanged: (state, { payload }) => {
      state.countryCode = payload;
      state.generateOtpReq.error = "";
    },
    onOTPChanged: (state, { payload }) => {
      state.otp = payload;
    },
    onPhoneOTPChanged: (state, { payload }) => {
      state.phoneOtp = payload;
      state.verifyOtpReq.error = "";
    },
    showOtp: (state) => {
      state.showOtp = true;
    },
    showPhoneOtp: (state) => {
      state.showOtp = true;
    },
    hideOtp: (state) => {
      state.showOtp = false;
    },
    hidePhoneOtp: (state) => {
      state.showOtp = false;
    },
    generateOtp: (state, { payload }) => {
      state.generateOtpReq.version = payload;
      state.generateOtpReq.status = "request";
    },
    generateOtpSuccess: (state, { payload = "" }: { payload?: string }) => {
      state.generateOtpReq.status = "success";
      state.showOtp = true;
      state.sessionUUId = payload;
    },
    generateOtpError: (state, { payload }) => {
      state.generateOtpReq.status = "failure";
      state.generateOtpReq.error = payload;
    },
    verifyOtp: (state) => {
      state.verifyOtpReq.status = "request";
    },
    verifyOtpSuccess: (state) => {
      state.verifyOtpReq.status = "success";
      state.showOtp = true;
      state.showLoginModal = false;
    },
    verifyOtpError: (state, { payload }) => {
      state.verifyOtpReq.status = "failure";
      state.verifyOtpReq.error = payload;
    },
    onGoogleOneTapLoaded: (state) => {
      state.googleOneTapLoaded = true;
    },
    setIsAcceptTC: (state, { payload }) => {
      state.isAcceptTC = payload;
    },
    resetState: (state) => ({
      ...initialState,
      showLoginModal: state.showLoginModal,
      googleOneTapLoaded: state.googleOneTapLoaded,
    }),
  },
});

export default loginData.reducer;
export const {
  resetState,
  setIsAcceptTC,
  changeLoginModalTitle,
  showLoginModal,
  hideLoginModal,
  onEmailChanged,
  onPhoneChanged,
  onCountryCodeChanged,
  showOtp,
  showPhoneOtp,
  hidePhoneOtp,
  onPhoneOTPChanged,
  generateOtp,
  generateOtpSuccess,
  generateOtpError,
  onOTPChanged,
  verifyOtp,
  verifyOtpError,
  verifyOtpSuccess,
  hideOtp,
  onGoogleOneTapLoaded,
} = loginData.actions;
